import { Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import type { ReservationDetailData } from "../../api/ApiData";
import { useApiContext } from "../../api/ApiProvider";
import lineLogin from "../../img/line_login.png";
import { ColorHexCodes } from "../../util/Color";
import CancellableReservationSummary from "../CancellableReservationSummary";
import PageWrapper from "../PageWrapper";
import Space from "../Space";

export default function ReservationDetail() {
  const { api } = useApiContext();
  const [reservationDetailData, setReservationDetailData] = useState<ReservationDetailData | null>();
  const searchParams = new URLSearchParams(window.location.search);
  const rid = searchParams.get("rid");

  useEffect(() => {
    if (rid) {
      api.getReservationData(rid).then((data) => setReservationDetailData(data));
    }
  }, [rid]);

  if (reservationDetailData === undefined) {
    return <Typography>予約情報を取得中</Typography>;
  }

  if (reservationDetailData === null) {
    return <Typography>該当する予約はありません</Typography>;
  }

  return (
    <PageWrapper storeGroupName={reservationDetailData.group.show_group_name ? reservationDetailData.group.name : ""}>
      <Typography fontSize="26px" textAlign="center">
        ご予約詳細
      </Typography>
      <Space h={20} />
      <Stack style={{ backgroundColor: "white", padding: "20px 30px" }}>
        {reservationDetailData.lineLoginUrl && (
          <div>
            <Stack alignItems="center" direction="row" spacing={2}>
              <Typography>LINEログインして予約通知を受け取る</Typography>
              <a href={reservationDetailData.lineLoginUrl} rel="noopener noreferrer" target="_blank">
                <img alt="Line login" height="32" src={lineLogin} width="110" />
              </a>
            </Stack>
            <Space h={15} />
            <div style={{ background: `#${ColorHexCodes.MainColorGreen}`, height: 1 }} />
            <Space h={15} />
          </div>
        )}
        <CancellableReservationSummary data={{ ...reservationDetailData }} />
      </Stack>
    </PageWrapper>
  );
}
